var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0074ba",
    d: "M17.328 11.51c-.2-.02-.4-.04-.6-.08c-1.24-.22-2.4-.78-3.34-1.64c-2.74-2.11-6.01-4.77-7.68-7.78h-.35c-1.45 0-2.36 1.56-1.65 2.82c1.32 2.33 3.18 4.31 5.42 5.77c.76.59 1.7.91 2.66.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8312f",
    d: "m16.737 11.295l-.58-4.075l-2.61-4.29c-.33-.58-.95-.93-1.62-.93H9.75l6.215 9.476a8 8 0 0 1-.287.034v.01h4.53c.97 0 1.9-.32 2.66-.91a16.55 16.55 0 0 0 5.42-5.77c.72-1.27-.2-2.83-1.64-2.83h-.35c-2.71 2.83-5.94 5.67-8.68 7.78c-.418.382-.484.705-.537.965c-.048.23-.085.41-.344.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    d: "m16.562 10.06l.18 1.27a6.65 6.65 0 0 0 2.876-1.54c2.74-2.11 5.01-4.77 6.68-7.78h-4.57zm-.188 1.45h-.046l.2.24zm-.406-.031q-.146.017-.29.031l-.2.24l.21-.327a6.66 6.66 0 0 1-3.3-1.633C9.648 7.68 7.17 5.01 5.5 2h4.388z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a6ed",
    d: "M22.108 2.01h-2.04c-.67 0-1.28.35-1.62.93l-5.22 8.58h2.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3883e",
    d: "m16.608 15.67l.83 1.72c.1.2.29.35.51.38l1.85.28c.55.08.78.78.37 1.18l-1.28 1.28c-.19.19-.25.47-.17.73l.59 1.71c.2.57-.36 1.11-.91.87l-2.14-.96a.64.64 0 0 0-.54 0l-2.14.96c-.54.24-1.11-.3-.91-.87l.59-1.71c.09-.26.02-.54-.17-.73l-1.28-1.28c-.4-.4-.18-1.1.37-1.18l1.85-.28c.22-.03.41-.17.51-.38l.83-1.72c.27-.52.99-.52 1.24 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb02e",
    d: "M15.99 30c5.545 0 10.04-4.607 10.04-10.29S21.535 9.42 15.99 9.42S5.95 14.027 5.95 19.71S10.445 30 15.99 30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd53f",
    d: "M16 28.76c-2.36 0-4.58-.94-6.24-2.65a9.1 9.1 0 0 1-2.59-6.4c0-2.42.92-4.69 2.59-6.4a8.69 8.69 0 0 1 12.49 0c3.44 3.53 3.44 9.27 0 12.8c-1.68 1.71-3.9 2.65-6.25 2.65m-.01-16.87c-1.95 0-3.91.76-5.39 2.29a7.87 7.87 0 0 0-2.23 5.53c0 2.09.79 4.05 2.23 5.53a7.48 7.48 0 0 0 5.39 2.29c2.04 0 3.95-.81 5.39-2.29c2.97-3.05 2.97-8.01 0-11.06a7.46 7.46 0 0 0-5.39-2.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6d4534",
    d: "m16.6 15.66l.83 1.72c.1.2.29.35.51.38l1.85.28c.55.08.78.78.37 1.18l-1.28 1.28c-.19.19-.25.47-.17.73l.59 1.71c.2.57-.36 1.11-.91.87l-2.14-.96a.64.64 0 0 0-.54 0l-2.14.96c-.54.24-1.11-.3-.91-.87l.59-1.71c.09-.26.02-.54-.17-.73l-1.28-1.28c-.4-.4-.18-1.1.37-1.18l1.85-.28c.22-.03.41-.17.51-.38l.83-1.72c.27-.52.99-.52 1.24 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadges);
export default __webpack_public_path__ + "static/media/badges.ae0b00e5d49a0930d4f929d915f0b611.svg";
export { ForwardRef as ReactComponent };